import type { HeaderState } from '../../../types/appState';
import type { Agent } from '../../../types/domain';
import { getLast } from '../../../util/guards';
import type { TRootState } from '../reducers';

export const selectIsEnabled = (state: TRootState): boolean => {
  return state.header.isEnabled;
};

export const selectAlert = (state: TRootState): HeaderState['announcement'] | undefined => {
  return state.header.announcement;
};

export const selectStatusBannerData = (state: TRootState): HeaderState['statusBanner'] | undefined => {
  return state.header.statusBanner;
};

export const hideStatusBannerData = (state: TRootState): boolean => {
  return state.header.hideStatusBanner;
};

export const selectOnlineAgent = (state: TRootState): Agent | undefined => {
  return getLast(state.header.onlineAgents);
};
